// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Add IP Address Button Component should match snapshot 1`] = `
<Button
  className="addIpAddress"
  disabled={false}
  key="create-ipaddress-list-form"
  onClick={[Function]}
  type="secondary"
>
  Add IP Address
</Button>
`;
